import React, { useState, useEffect } from 'react'
import { Box, IconButton, Typography, useTheme, Button, Backdrop, CircularProgress, Dialog, Collapse } from '@material-ui/core'
import { ArrowBack } from '@material-ui/icons'
import { Link } from 'react-router-dom'
import ScheduleItem from './ScherduleItem'
import { useDataProvider, useTranslate, Loading } from 'react-admin';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { lightBlue, grey } from '@material-ui/core/colors';
import { fetchUtils } from 'react-admin';
import { getDimensions, isVideo, isImage } from "../utils";
import DialogEdit from './Dialog-EditChannel.jsx';
import PreviewSchedule from './Dialog-PreviewSchedule.jsx';
import { baseAuthUrl } from '../authProvider'
import Snackbar from '../common/snackbar';
import emailSend from '../assets/infochanges.png'
import { Close } from '@material-ui/icons';
import { useHistory, Prompt } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isBlockingInfoChannel, pathNameInfoChannel } from '../infochannels/action';
import { useDispatch } from 'react-redux';
import ConfirmDialog from '../CustomizedUIs/confirmDialog'
import { LoadingButton } from '../common/button';
import { Alert } from '@material-ui/lab'
import TextButton from '../CustomizedUIs/TextButton'
import GoBackButton from '../CustomizedUIs/GoBackButton'
import CloseButton from '../CustomizedUIs/CloseButton'

const useStyles = makeStyles((theme) =>
    createStyles({
        Container: {
            width: '800px'
        },
        table: {
            minWidth: 650,
        },
        Button: {
        },
        Card: {
            marginTop: '2em',
            padding: '1em'
        },
        buttonProgress: {
            color: 'blue',
            position: 'absolute',
            left: 23,
            top: 5
        },
        name: {
            width: '25em',
            minWidth: '25em',
            maxWidth: '25em',
            wordBreak: 'break-all'
        },
        tableCell: {
            borderBottom: 'solid 5px ' + theme.palette.background.default
        },
        expandText: {
            fontSize: 10,
            fontWeight: 'bold',
            color: grey[500]
        },
        expandGroup: {
            width: 150,
            height: 30,
            float: 'right',
            backgroundColor: theme.palette.common.white,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-around'
        },
        TextRole: {
            fontFamily: 'UniviaPro-Book',
            fontSize: '13px',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 'normal',
            letterSpacing: 'normal',
            color: '#4f5064',
            paddingLeft: 20,
        },

        btnSave: {
            fontFamily: 'UniviaPro-Bold',
            fontSize: '11px',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 'normal',
            letterSpacing: '0.44px',
            color: '#ffffff',
        },
        TitleUnSave: {
            fontFamily: 'UniviaPro-Book',
            fontSize: '22px',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.25,
            letterSpacing: 'normal',
            color: 'rgba(0, 0, 0, 0.87)',
        },
        ConstentUnSave: {
            fontFamily: 'UniviaPro-Book',
            fontSize: '12px',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.25,
            letterSpacing: 'normal',
            color: 'rgba(0, 0, 0, 0.87)',
            paddingTop: '10px'
        },
        textClose: {
            fontFamily: 'UniviaPro',
            fontSize: '10px',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 'normal',
            letterSpacing: '0.4px',
            color: '#4f5064',
        },
        BorderClose: {
            width: '25px',
            height: '25px',
            border: 'solid 2px #e5f1f8',
            backgroundColor: '#ffffff',
            marginLeft: '10px'
        },
        container: {
            width: 450,
            textAlign: 'center',
            backgroundColor: '#f3f7fa',
            paddingBottom: theme.spacing(5)
        },
        image: {
            width: '50%',
            height: '50%',
            marginTop: 32,
            marginBottom: 32
        },
        paper: {
            display: 'block'
        },
        disabled: {
            cursor: 'pointer',
            borderBottomColor: grey['900'],
            pointerEvents: 'none',
            opacity: 0.4
        },
        enabled: {
            cursor: 'pointer',
            borderBottomColor: lightBlue['100']
        },

    }),

);


const Edit = (props) => {
    const theme = useTheme()
    const [data, setData] = useState([])
    const [channelName, setChannelName] = useState('')
    const [files, setFiles] = useState([])
    const [removes, setRemoves] = useState([])
    const dataProvider = useDataProvider()
    const [loading, setLoading] = useState(false)
    const [loadingPage, setLoadingPage] = useState(false)
    const [openEdit, setOpenEdit] = useState(false)
    const [selectedSchedule, setSelectedSchedule] = useState(0)
    const [openPreview, setOpenPreview] = useState(false)
    const [showSnackbar, setShowSnackbar] = useState(false)
    const [open, setOpen] = useState(false);
    const history = useHistory();
    let is_blocking = useSelector((state) => state.is_blocking_infochannel);
    const path_name = useSelector((state) => state.path_name_infochannel);
    const dispatch = useDispatch();
    const classes = useStyles();
    const [openAlert, setOpenAlert] = useState(false)
    const [messageError, setMessageError] = useState('')
    const [isOverlap, setIsOverlap] = useState(false)
    const translate = useTranslate();
    // const onOpenEdit = () => {
    //     setOpenEdit(true)
    // }
    const closeEdit = () => {
        setOpenEdit(false)
    }
    const handleClose = () => {
        // is_blocking = false;
        // dispatch(isBlockingInfoChannel(is_blocking)) 
        setOpen(false)
    }
    const handleCancelDialog = () => {
        is_blocking = false;
        dispatch(isBlockingInfoChannel(is_blocking))
        history.replace(path_name)

    }

    const addSchedule = () => {
        dispatch(isBlockingInfoChannel(true))
        let temps = [...data]
        let currentDate = new Date()
        temps.unshift({
            resolution: null,
            typeName: 'One time',
            defaultShowTime: 12,
            startDate: currentDate.getTime(),
            stopDate: currentDate.getTime(),
            startTime: `${currentDate.getHours()}:${currentDate.getMinutes() < 30 ? `00` : 30}`,
            stopTime: `${currentDate.getMinutes() >= 30 ? currentDate.getHours() + 1 : currentDate.getHours()}:${currentDate.getMinutes() < 30 ? `30` : `00`}`,
            sound: "",
            fileOfSchedule: [],
            disableInteraction: false
        })
        setData(temps)
    }

    const getTimeOfDate = (timeStamp) => {
        var date = new Date(timeStamp)
        date.setHours(0, 0, 0, 0)
        return date
    }

    const convertDateFromHouse = (time) => {
        var date = Date.parse(`01/01/2011 ${time}:00`)
        return date
    }

    const checkDayOverlap = (date1, date2) => {
        let day1 = new Date(date1).getDay()
        let day2 = new Date(date2).getDay()
        return day1 === day2
    }


    const check = (channel, index) => {
        var flag = false
        for (let i = 0; i < data.length; i++) {
            let infoChannel = data[i]
            if (infoChannel.typeName === 'Always' && data.length > 1) {
                flag = true
                break
            }
            else if (((getTimeOfDate(channel.startDate) >= getTimeOfDate(infoChannel.startDate) && getTimeOfDate(channel.startDate) <= getTimeOfDate(infoChannel.stopDate))
                || (getTimeOfDate(channel.stopDate) >= getTimeOfDate(infoChannel.startDate) && getTimeOfDate(channel.stopDate) <= getTimeOfDate(infoChannel.stopDate))
                || (getTimeOfDate(channel.startDate) <= getTimeOfDate(infoChannel.stopDate) && channel.noEndDate)) && index !== i) {
                if ((convertDateFromHouse(channel.startTime) >= convertDateFromHouse(infoChannel.startTime)
                    && convertDateFromHouse(channel.startTime) <= convertDateFromHouse(infoChannel.stopTime))
                    || (convertDateFromHouse(channel.stopTime) >= convertDateFromHouse(infoChannel.startTime)
                        && convertDateFromHouse(channel.stopTime) <= convertDateFromHouse(infoChannel.stopTime))) {
                    if ((infoChannel.typeName === 'Weekly' && channel.typeName === 'Weekly')
                        || (infoChannel.typeName === 'Weekly' && channel.typeName === 'Monthly')
                        || (infoChannel.typeName === 'Monthly' && channel.typeName === 'Monthly')
                        || (infoChannel.typeName === 'Monthly' && channel.typeName === 'Weekly')) {
                        if (checkDayOverlap(infoChannel.startDate, channel.startDate)) {
                            flag = true
                            break
                        }

                    }
                    else if ((infoChannel.typeName === 'Monthly' && channel.typeName === 'Weekdays')
                        || (infoChannel.typeName === 'Weekly' && channel.typeName === 'Weekdays')) {
                        if (new Date(infoChannel.startDate).getDay() !== 0 && new Date(infoChannel.startDate).getDay() !== 6) {
                            flag = true
                            break
                        }
                    }
                    else if ((infoChannel.typeName === 'Weekdays' && channel.typeName === 'Monthly')
                        || (infoChannel.typeName === 'Weekdays' && channel.typeName === 'Weekly')) {
                        if (new Date(channel.startDate).getDay() !== 0 && new Date(channel.startDate).getDay() !== 6) {
                            flag = true
                            break
                        }
                    }
                    else {
                        flag = true
                        break
                    }

                }
            }
        }
        return flag
    }

    const checkOverlap = () => {
        var flag = false
        for (let i = 0; i < data.length; i++) {
            let infoChannel = data[i]
            if (check(infoChannel, i)) {
                flag = true
                break
            }
        }
        return flag
    }

    const onSave = () => {

        if (checkOverlap())
            setIsOverlap(true)
        else {
            is_blocking = false;
            dispatch(isBlockingInfoChannel(is_blocking))
            setOpen(false)
            const formData = new FormData();
            formData.append('channel', parseInt(props.match.params.id));
            formData.append('removeItems', JSON.stringify(removes))
            let filemapping = [];
            data.forEach((item, index) => {
                item.fileOfSchedule.forEach((fileOfSchedule, idx) => {
                    fileOfSchedule.index = idx;
                });
            });
            formData.append('schedules', JSON.stringify(data));

            for (let idxf = 0; idxf < files.length; idxf++) {
                const f = files[idxf];
                filemapping.push(f.filemapping);
            }
            formData.append('filemapping', JSON.stringify(filemapping));

            for (let idxf = 0; idxf < files.length; idxf++) {
                const f = files[idxf];
                formData.append('file', f, f.name);
            }
            setLoading(true);
            dataProvider('UPLOAD', "infochannelschedule", formData)
                .then(({ data }) => {

                    //props.history.push('/infochannel');

                    setTimeout(() => {
                        setLoading(false);
                        setShowSnackbar(true)
                        getList()
                        setTimeout(() => setShowSnackbar(false), 6000)
                    }, 3000)

                })
                .catch(error => {
                    if (error.message.includes('Upload limit is')) {
                        setMessageError(error.message)
                        setOpenAlert(true)
                        window.scrollTo(0, 0)
                        setTimeout(() => setOpenAlert(false), 6000)
                    }
                    setLoading(false);
                })
        }

    }

    const onPreview = (index) => {
        setSelectedSchedule(index);
        setOpenPreview(true);
    }

    const onClosePreview = () => {
        setSelectedSchedule(0);
        setOpenPreview(false);
    }

    const onDisableInteractionChanged = (index) => {
        dispatch(isBlockingInfoChannel(true))
        const newData = [...data];
        newData[index].disableInteraction = !newData[index].disableInteraction;
        setData(newData);
    }

    const onDragAndDropFiles = (newFiles, index) => {
        dispatch(isBlockingInfoChannel(true))
        const newData = [...data];
        newData[index].fileOfSchedule = newFiles;
        setData(newData);
    }

    const getList = () => {
        setLoadingPage(true)
        dataProvider('GET_ONE', "getinfochannelschedule", {
            id: props.match.params.id
        })
            .then(async ({ data }) => {
                let temps = [...data];
                temps.map(item => {
                    if (item.sound !== '')
                        item.sound = JSON.parse(item.sound)
                    return item
                })
                temps = temps.sort(function (a, b) { return b.createdAt - a.createdAt });
                for (let i = 0; i < temps.length; i++) {
                    temps[i].fileOfSchedule.sort((a, b) => a.index - b.index);
                    const item = temps[i].fileOfSchedule;
                    for (let j = 0; j < item.length; j++) {
                        item[j].fileId = item[j].id + '';
                        if (item[j].dimension) {
                            const dimension = item[j].dimension.replace('px', '').split('x');
                            item[j].dimension = { width: dimension[0], height: dimension[1] };
                        } else {
                            let dimension = { width: '100', height: '100' };
                            if (isVideo(item[j].type) || isImage(item[j].type))
                                dimension = await getDimensions(`${baseAuthUrl}/media/${item[j].fd}`, item[j].type);
                            item[j].dimension = dimension;
                        }
                    }
                }
                setData(temps.reverse());
                dataProvider('GET_LIST', "infochannels", {
                    filter: {
                    },
                    pagination: {},
                    sort: { field: 'name', order: 'ASC' },

                }).then((idata) => {
                    if (idata && idata.data) {
                        let rData = idata.data;
                        const value = rData.filter(e => e.id == props.match.params.id)[0]?.name;
                        setChannelName(value);
                    }
                    setLoadingPage(false)
                }).catch(error => {
                    setLoadingPage(false)
                })
            })

            .catch(error => {

                setLoadingPage(false);
            })
    }

    useEffect(() => {
        if (!openEdit) {
            getList()
        }

    }, [openEdit])
    if (loadingPage) return <Loading />
    if (!data) return null

    return (
        <Box width='80%' m='auto'>
            <Prompt
                when={is_blocking}
                message={location => {
                    if (is_blocking) {
                        dispatch(pathNameInfoChannel(location.pathname))
                        setOpen(true);
                        return false;
                    } else {
                        return true;
                    }
                }}
            />
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" classes={{
                paper: classes.paper
            }} >
                <Box className={classes.container}>
                    <Box display='flex' justifyContent='flex-end' alignItems='center' mr={2} pt={1}>
                        <Typography className={classes.textClose}>{translate(`pos.common.close`)}</Typography>
                        <CloseButton onClick={handleClose} />
                    </Box>
                    <img alt='image-save' src={emailSend} className={classes.image} />
                    <Typography className={classes.TitleUnSave}>{translate('resources.role.TitleUnsave')}</Typography>
                    <Typography className={classes.ContentUnSave}>{translate('resources.role.ConstTentUnsave')}</Typography>

                    <Box mt={3}>
                        <TextButton
                            style={{ marginTop: 16, marginRight: 20 }}
                            onClick={handleCancelDialog}
                        />

                        <LoadingButton
                            label={translate(`resources.role.Save`)}
                            onClick={onSave}
                        />
                    </Box>
                </Box>

            </Dialog>
            <Box mt={3}>
                <Collapse in={openAlert}>
                    <Alert severity={"error"}>{messageError}</Alert>
                </Collapse>
            </Box>
            <Box width='100%' display='flex' justifyContent='flex-end' mt={2}>
                <Snackbar
                    show={showSnackbar}
                    boldText=''
                    message={translate(`resources.room.saveSuccess`)}
                    onClose={() => setShowSnackbar(false)}
                />
            </Box>
            <Box>
                <Box my={5} width={300} display='flex' component={Link} to={'/infochannel'} style={{ textDecoration: 'none' }}>
                    <Box display='flex' mr={2}>
                        <GoBackButton />
                    </Box>
                    <Typography variant="subtitle1" color="primary" style={{ margin: 'auto 0', fontWeight: 'bold' }}>{translate(`pos.channels.backToChannelList`)}</Typography>
                </Box>
            </Box>
            <Box display='flex' style={{ borderBottom: '1px solid #DEEBF4' }} pb={2}>
                <Box flexGrow={1}>
                    <Typography variant='h5' style={{ fontFamily: 'UniviaPro-Medium', fontWeight: 500, lineHeight: '21.6px', color: '#4f5064', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'pre', maxWidth: '1100px' }}>{channelName}</Typography>
                    <Typography variant='h5' style={{ fontFamily: 'UniviaPro-Medium', fontStyle: 'italic', fontSize: 'small' }}>*{translate("pos.infochannel.warningMsg")}</Typography>
                </Box>
                <Box>
                    {/*<Button style={{ marginRight: theme.spacing(2) }} variant='contained' color='primary' onClick={onPreview}>Preview</Button>*/}
                    <Button style={{ marginRight: theme.spacing(2), fontFamily: 'UniviaPro-Bold', fontSize: 9, lineHeight: '11px', letterSpacing: '0.36px', padding: 8 }}
                        variant='contained' color='primary' onClick={onSave}>{translate(`pos.common.save`)}</Button>
                    {/* <Button style={{ marginRight: theme.spacing(2) }} variant='contained' color='primary' onClick={onOpenEdit}>Edit channel</Button> */}
                    <Button style={{ fontFamily: 'UniviaPro-Bold', fontSize: 9, lineHeight: '11px', letterSpacing: '0.36px', padding: 8 }}
                        variant='contained' color='primary' onClick={addSchedule}>
                        {translate(`pos.channels.addSchedule`)}
                    </Button>
                    <DialogEdit open={openEdit} handleClose={closeEdit} infoChannel={parseInt(props.match.params.id)}></DialogEdit>
                    <PreviewSchedule open={openPreview} handleClose={onClosePreview} scheduleData={data[selectedSchedule]?.fileOfSchedule} resolution={data[selectedSchedule]?.resolution} pivot={data[selectedSchedule]?.pivot} sound={data[selectedSchedule]?.sound} />
                </Box>
            </Box>
            <Box my={2}>
                {
                    data.map((item, index) => (
                        <Box key={"schedule-" + index} mb={4}>
                            <ScheduleItem item={item} data={data} removes={removes} setRemoves={setRemoves} files={files} setFiles={setFiles} setData={setData} index={index} onPreview={onPreview}
                                onDisableInteractionChanged={() => onDisableInteractionChanged(index)}
                                onDragAndDropFiles={onDragAndDropFiles}
                            />
                        </Box>
                    ))
                }

            </Box>
            <Backdrop style={{ zIndex: 1000 }} open={loading} >
                <CircularProgress color="inherit" />
            </Backdrop>
            <ConfirmDialog
                open={isOverlap}
                handleClose={() => setIsOverlap(false)}
                handleConfirm={() => setIsOverlap(false)}
                Tittle={''}
                ContentText={translate('pos.common.contentOverlap')} />
        </Box>
    )
}

export default Edit